import { api } from "./api";

export const createLogin = async (body: unknown): Promise<any> => {
  const { data } = await api.post("/user/create-login", body);
  return data;
};

export const getUser = async (): Promise<any> => {
  const { data } = await api.get("/user/me");
  return data;
};

export const sendTokenByUserId = async (body: {
  phone?: string | null;
}): Promise<any> => {
  const { data } = await api.post("/user/send-token", body);
  return data;
};

export const validateUserToken = async (body: {
  token: string;
  phone: string;
}): Promise<any> => {
  const { data } = await api.post("/user/validate-token", body);
  return data;
};

export const checkUserByPhone = async (params: any): Promise<any> => {
  const { data } = await api.get("/user/check-user-phone", { params });
  return data;
};
